import * as State from 'components/desktop/_general/UnitWeightEditor/UnitWeightEditorState';
import { useHandler } from 'hooks/useHandler';

export default function useUnitWeightEditorState() {
	const [state, rf] = useHandler<State.Type>(State.create());

	return {
		state,
		handlers: {
			resetValues: rf.createNoArgReducer(State.resetValues),
			getSuggestedUnitWeight: rf.createReducerAsync(State.getSuggestedUnitWeight),
			setIsLoadingAi: rf.createReducer(State.setIsLoadingAi),
			setSelectedUnit: rf.createReducer(State.setSelectedUnit),
			setWeight: rf.createReducer(State.setWeight),
		},
	};
}
